import { render, staticRenderFns } from "./popup-jia-gong-choose-more.vue?vue&type=template&id=235fedea&scoped=true"
import script from "./popup-jia-gong-choose-more.vue?vue&type=script&lang=js"
export * from "./popup-jia-gong-choose-more.vue?vue&type=script&lang=js"
import style0 from "./popup-jia-gong-choose-more.vue?vue&type=style&index=0&id=235fedea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235fedea",
  null
  
)

export default component.exports